var _ = /* @__PURE__ */ ((r) => (r.NAV_CLICK = "nav_click", r))(_ || {}), I = /* @__PURE__ */ ((r) => (r.MASTHEAD = "masthead", r.FOOTER = "footer", r))(I || {}), O = /* @__PURE__ */ ((r) => (r.BUTTON = "button", r.LINK = "link", r.CAROUSEL = "carousel", r.GRID = "grid", r.FORM = "form", r))(O || {}), u = /* @__PURE__ */ ((r) => (r.UI_ENGAGEMENT = "ui_engagement", r.AD_CLICK = "ad_click", r.MODAL_VIEW = "modal_view", r.OFFER_CLICK = "offer_click", r.OFFER_VIEW = "offer_view", r))(u || {});
export {
  u as AnalyticsEventType,
  _ as ClickAction,
  O as ComponentType,
  I as Placement
};
